export const getProfileImageUrl = (profilePic) => {
  const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
  const DEFAULT_IMAGE = "/uploads/users/default.png";

  // If no profilePic
  if (!profilePic) {
    const url = `${BASE_URL}${DEFAULT_IMAGE}`;

    return url;
  }

  // If already full URL → return directly
  if (profilePic.startsWith("http")) {
    console.log("🌐 Full URL detected:", profilePic);
    return profilePic;
  }

  let cleanPath = profilePic;

  // Normalize slashes
  cleanPath = cleanPath.replace(/\\/g, "/");

  // Remove duplicate uploads
  if (cleanPath.includes("/uploads/uploads/")) {
    cleanPath = cleanPath.replace("/uploads/uploads/", "/uploads/");
  }

  // Ensure leading slash
  if (!cleanPath.startsWith("/")) {
    cleanPath = `/${cleanPath}`;
  }

  const finalUrl = `${BASE_URL}${cleanPath}`;

  return finalUrl;
};
